import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Building, Users, Briefcase, Globe, Target, ChevronRight, PlusCircle, Save, ArrowRight } from 'lucide-react';
import LeftSidebar from '../LeftSidebar/LeftSidebar';
import { leadsAPI } from '../../api/leads';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Header from '../Header/Header';
import CreatableSingleSelect from '../CustomSelects/CreatableSingleSelect';
import { industriesData } from "./indurstriesData";
import SearchableSingleSelect from '../CustomSelects/SearchableSingleSelect';
import * as amplitude from '@amplitude/analytics-browser';
import { useAuth } from "../../context/AuthContext";

const ICPDefinitionPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { user } = useAuth();

  // const [icpName, setIcpName] = useState('');
  const [naturalLanguageDescription, setNaturalLanguageDescription] = useState('');
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [selectedCompanySizes, setSelectedCompanySizes] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [newRole, setNewRole] = useState('');
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [customFilters, setCustomFilters] = useState([{ name: '', value: '' }]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [remainingCalls, setRemainingCalls] = useState(3);
  const [selectedListName, setSelectedListName] = useState(null);
  const [listNameOptions, setListNameOptions] = useState([]);


  // const [industries, setIndustries] = useState([
  //   "Civil Engineering", "Building Structure and Exterior Contractors", "Architecture and Planning", "Construction",
  //   // "Technology", "Healthcare", "Finance", "Education", "Manufacturing",
  //   // "Retail", "Real Estate", "Legal", "Consulting", "Marketing"
  // ]);


  const [industries, setIndustries] = useState(industriesData);

  const [companySizes, setCompanySizes] = useState([
    { label: "Self-employed", value: "Self-employed" },
    { label: "1-10 employees", value: "1-10" },
    { label: "11-50 employees", value: "11-50" },
    { label: "51-200 employees", value: "51-200" },
    { label: "201-500 employees", value: "201-500" },
    { label: "501-1,000 employees", value: "501-1,000" },
    { label: "1,001-5,000 employees", value: "1,001-5,000" },
    { label: "5,001-10,000 employees", value: "5,001-10,000" },
    { label: "10,001+ employees", value: "10,001+" }
  ]);
  //   "1-10 employees", "11-50", "51-200 employees",
  //   "201-500 employees", "501-1000 employees", "1001-5000 employees", "5000+ employees"
  // ];

  const [roles, setRoles] = useState([
    "CEO", "CTO", "CFO", "CMO", "COO", "VP of Sales", "VP of Marketing",
    "Director of IT", "Sales Manager", "Marketing Manager", "HR Director"
  ]);

  // const roles = [
  //   "Director of Preconstruction",
  //   "Preconstruction Manager",
  //   "Civil Engineering Director",
  //   "Senior Project Manager",
  //   "Construction Operations Director",
  //   "Architectural Director"
  // ]

  // const [locations, setLocations] = useState([
  //   "United States", "Europe", "Asia Pacific", "Canada", "United Kingdom",
  //   "Germany", "France", "Australia", "India", "Japan"
  // ]);

  const [locations, setLocations] = useState([
    "Oceania",
    "EMEA",
    "DACH",
    "North America",
    "Benelux",
    "APJ",
    "APAC",
    "Asia",
    "Nordics",
    "MENA",
    "Europe",
    "Africa",
    "South America"
  ]);


  const showSuccessMessageHanlder = (val) => {
    toast.success(val, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showErrorMessageHanlder = (val) => {
    toast.error(val, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };


  const handleIndustryToggle = (industry) => {
    if (industry) {
      if (selectedIndustries.includes(industry)) {
        setSelectedIndustries(selectedIndustries.filter(i => i !== industry));
      } else {
        setSelectedIndustries([...selectedIndustries, industry]);
      }
    }
  };

  // const handleCompanySizeToggle = (size) => {
  //   if (selectedCompanySizes.includes(size)) {
  //     setSelectedCompanySizes(selectedCompanySizes.filter(s => s !== size));
  //   } else {
  //     setSelectedCompanySizes([...selectedCompanySizes, size]);
  //   }
  // };

  const handleCompanySizeToggle = (size) => {
    if (selectedCompanySizes.some(s => s.value === size.value)) {
      setSelectedCompanySizes(selectedCompanySizes.filter(s => s.value !== size.value));
    } else {
      setSelectedCompanySizes([...selectedCompanySizes, size]);
    }
  };


  // No longer needed as we're using a different approach for roles

  const handleLocationToggle = (location) => {
    if (selectedLocations.includes(location)) {
      setSelectedLocations(selectedLocations.filter(l => l !== location));
    } else {
      setSelectedLocations([...selectedLocations, location]);
    }
  };

  const addCustomFilter = () => {
    setCustomFilters([...customFilters, { name: '', value: '' }]);
  };

  const updateCustomFilter = (index, field, value) => {
    const updated = [...customFilters];
    updated[index][field] = value;
    setCustomFilters(updated);
  };

  const removeCustomFilter = (index) => {
    const updated = [...customFilters];
    updated.splice(index, 1);
    setCustomFilters(updated);
  };


  const clearFiltersHandler = () => {
    // setIcpName('');
    setSelectedListName(null);
    setNaturalLanguageDescription('');
    setSelectedIndustries([]);
    setSelectedCompanySizes([]);
    setSelectedRoles([]);
    setSelectedLocations([]);
  };

  const handleAmplitudeEventTrigger = () => {
    amplitude.track('Lead Generation Event Triggered', {
      userId: user?.id,
    });
    // console.log(`amplitude works`, user?.id)
  };
  const handleGenerateLeads = async () => {
    if (!selectedListName || !selectedListName.value.trim()) {
      showErrorMessageHanlder(`Please select a list name, you can create one if no list name was exits.`);
      return;
    }
    handleAmplitudeEventTrigger()
    setIsGenerating(true);

    // Simulate API call or loading state
    // setTimeout(() => {
    //   setIsGenerating(false);
    //   // Navigate to the leads dashboard (would be implemented with routing in a real app)
    //   console.log("Navigate to leads dashboard");
    // }, 2000);



    let data = {};
    // console.log("selectedIndustries", selectedIndustries);
    // console.log("selectedCompanySizes", selectedCompanySizes);
    // console.log("selectedRoles", selectedRoles);
    // console.log("selectedLocations", selectedLocations);
    data.job_titles = selectedRoles || [];
    data.region = selectedLocations || [];
    data.industries = selectedIndustries || [];
    data.company_sizes = selectedCompanySizes && selectedCompanySizes.length > 0 ? selectedCompanySizes?.map(s => s?.value) : [];
    data.list_name = selectedListName;

    console.log("payload data", data);

    try {
      const response = await leadsAPI.genarateLeads(data);
      console.log(`response leadsAPI.genarateLeads ->`, response);
      if (response?.statusCode === 201 || response?.statusCode === 200) {
        showSuccessMessageHanlder(response?.message || `Leads generated successfully`);
      } else {
        showErrorMessageHanlder(response?.message || `Error generating leads`);
      }
    } catch (err) {
      console.error('Error genrating leads:', err);
      showErrorMessageHanlder(err?.response?.data?.message || `Error generating leads`);
    } finally {
      setIsGenerating(false);
      clearFiltersHandler();
      setRemainingCalls((prev) => prev - 1);
      setTimeout(() => {
        navigate(`/leads`);
      }, 3000);
    }
  };

  const handleSaveProfile = () => {
    // Save ICP profile logic would go here
    console.log("ICP Profile saved");
  };



  const canGenarateLeadsHandler = async () => {
    try {
      const response = await leadsAPI.canGenarateLeads();
      // console.log(`response in canGenarateLeadsHandler ->`, response);
      if (response.statusCode === 200) {
        setRemainingCalls(response?.remainingCalls);
      }
    } catch (error) {
      console.error('Error in checking rate limit before genrating leads:', error);
      setRemainingCalls(3);
    }
  };

  const getLeadsGroups = async () => {
    try {
      const response = await leadsAPI.getLeadGroups();
      // console.log(`response in getLeadGroups ->`, response);
      if (response.statusCode === 200) {
        setListNameOptions(response?.data || []);
      }
    } catch (error) {
      console.error('Error in getting leads groups:', error);
      setListNameOptions([]);
    }
  };

  const selectedNewOptionHandler = (value) => {
    // console.log('selectedNewOptionHandler', value);
    setSelectedListName(value);
  }

  useEffect(() => {
    canGenarateLeadsHandler();
    getLeadsGroups();
  }, []);

  //   useEffect(() => {
  //     console.log("Updated listNameOptions:", listNameOptions);
  // }, [listNameOptions]); // Runs when `listNameOptions` updates


  return (

    <div className="max-w-8xl mx-auto grid grid-cols-1 lg:grid-cols-8">
      <LeftSidebar />
      <div className="lg:col-span-7 relative" style={isGenerating ? { height: '100vh', overflow: 'hidden' } : {}}>
        <div className="max-w-8xl mx-auto py-6 px-6 bg-white sticky top-0 z-50" style={{ borderLeftWidth: 1 }}>
          <span className="text-xs text-gray-500">
            <Link
              to="/leads"
              className="hover:underline hover:text-[#45185a] cursor-pointer"
            >
              Leads
            </Link>{" "}
            / {"AddLeads"}
          </span>
        </div>
        {/* Blur Overlay (Visible only when loading) */}
        {isGenerating && (
          <div className="absolute inset-0 bg-white/50 flex items-center justify-center z-10"
            style={{ backdropFilter: "blur(2px)" }}>
            <div className="text-gray-700 text-lg font-semibold">Generating Leads <span className="dots"></span></div>
          </div>
        )}
        {/* <LeadsTable /> */}
        <div className={isGenerating ? `relative` : 'min-h-screen relative'}>
          <header className="pt-2 px-6">
            <div className="mx-auto">
              <h1 className="text-2xl font-bold text-gray-800">Define Your Ideal Customer Profile</h1>
              <p className="text-gray-600 mt-1">Set criteria for the leads you want to generate and reach out to</p>
            </div>
          </header>

          <main className="mx-auto p-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Left Column - Main ICP Definition */}
              <div className="lg:col-span-2 space-y-6">
                {/* ICP Name and Description */}
                <div className="bg-white rounded-lg shadow p-6">
                  <div className="mb-2">
                    <label htmlFor="icp-name" className="block text-sm font-medium text-gray-700 mb-1">List name</label>
                    {/* <input
                      type="text"
                      id="icp-name"
                      className="w-full p-2 border rounded"
                      placeholder="e.g., Enterprise Tech Buyers"
                      value={icpName}
                      onChange={(e) => setIcpName(e.target.value)}
                    /> */}
                    {/* <p className="text-xs text-gray-500">
                      Required Field
                    </p> */}
                    <CreatableSingleSelect optionsProp={listNameOptions || []} selectedNewOptionHandler={selectedNewOptionHandler} />
                  </div>

                  {/* <div>
                    <label htmlFor="natural-description" className="block text-sm font-medium text-gray-700 mb-1">
                      Describe your ideal customer in natural language
                    </label>
                    <textarea
                      id="natural-description"
                      rows={4}
                      className="w-full p-3 border rounded"
                      placeholder="e.g., I'm looking for mid-size technology companies that are growing rapidly and need better CRM solutions. The decision-makers should be VPs of Sales or Marketing who are struggling with scaling their sales processes."
                      value={naturalLanguageDescription}
                      onChange={(e) => setNaturalLanguageDescription(e.target.value)}
                    />
                    <p className="text-sm text-gray-500 mt-2">
                      The AI will use this description to better understand your target audience and generate more relevant leads.
                    </p>
                  </div> */}
                </div>

                {/* Industries */}
                {/* <div className="bg-white rounded-lg shadow p-6">
                  <div className="flex items-center mb-4">
                    <Building className="text-[#45185a] mr-2" />
                    <h2 className="text-lg font-medium">Industries</h2>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {industries && industries.slice(0, 10).map((industry) => (
                      <button
                        key={industry}
                        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors 
                      ${selectedIndustries.includes(industry)
                            ? 'bg-[#cb90fc] text-[#45185a] border border-[#45185a]'
                            : 'bg-gray-100 text-gray-800 border border-gray-200 hover:bg-gray-200'}`}
                        onClick={() => handleIndustryToggle(industry)}
                      >
                        {industry}
                      </button>
                    ))}
                  </div>
                </div> */}

                <div className="bg-white rounded-lg shadow p-6">
                  <div className="flex items-center mb-4">
                    <Building className="text-[#45185a]  mr-2" />
                    <h2 className="text-lg font-medium">Industries</h2>
                  </div>

                  <div className="mb-4">
                    {/*<div className="flex">
                       <input
                        type="text"
                        className="flex-1 p-2 border rounded-l"
                        placeholder="Add custom role or job title"
                        value={newRole}
                        onChange={(e) => setNewRole(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && newRole.trim()) {
                            setSelectedRoles([...selectedRoles, newRole.trim()]);
                            setNewRole('');
                          }
                        }}
                      />
                      <button
                        className="bg-[#45185a] text-white px-4 rounded-r hover:bg-[#5e2c73]"
                        onClick={() => {
                          if (newRole.trim()) {
                            setSelectedRoles([...selectedRoles, newRole.trim()]);
                            setNewRole('');
                          }
                        }}
                      >
                        Add
                      </button>
                        </div> */}
                    <SearchableSingleSelect
                      optionsProp={
                        industries && industries.filter((i) => !selectedIndustries.includes(i)).map((industry) => ({ label: industry, value: industry })) || []
                      }
                      selectedNewOptionHandler={(val) => handleIndustryToggle(val?.value || null)}
                    />

                    <p className="text-xs text-gray-500 mt-1">Search an industry and press enter or click on it to add</p>
                  </div>

                  <div className="mb-3">
                    <h3 className="text-sm font-medium text-gray-700 mb-2">Common industries (click to add):</h3>
                    <div className="flex flex-wrap gap-2">
                      {industries && industries.slice(0, 10).map((industry) => (
                        <button
                          key={industry}
                          className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors 
                      ${selectedIndustries.includes(industry)
                              ? 'bg-[#cb90fc] text-[#45185a] border border-[#45185a]'
                              : 'bg-gray-100 text-gray-800 border border-gray-200 hover:bg-gray-200'}`}
                          onClick={() => handleIndustryToggle(selectedIndustries.includes(industry) ? null : industry)}
                        >
                          {industry}
                        </button>
                      ))}
                    </div>
                  </div>

                  {selectedIndustries.length > 0 && (
                    <>
                      <h3 className="text-sm font-medium text-gray-700 mb-2">Selected Industries:</h3>
                      <div className="flex flex-wrap gap-2">
                        {selectedIndustries.map((industry, index) => (
                          <div
                            key={index}
                            className="px-3 py-1.5 rounded-full text-sm font-medium bg-[#cb90fc] text-[#45185a] border border-[#45185a] flex items-center"
                          >
                            {industry}
                            <button
                              className="ml-1.5 text-[#45185a]  hover:text-[#5e2c73] font-bold"
                              onClick={() => setSelectedIndustries(selectedIndustries.filter(r => r !== industry))}
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>

                {/* Company Size */}
                <div className="bg-white rounded-lg shadow p-6">
                  <div className="flex items-center mb-4">
                    <Users className="text-[#45185a]  mr-2" />
                    <h2 className="text-lg font-medium">Company Size</h2>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {companySizes.map((size) => (
                      <button
                        key={size.value}
                        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors 
                      ${selectedCompanySizes.some(s => s.value === size.value)
                            ? 'bg-[#cb90fc] text-[#45185a] border border-[#45185a]'
                            : 'bg-gray-100 text-gray-800 border border-gray-200 hover:bg-gray-200'}`}
                        onClick={() => handleCompanySizeToggle(size)}
                      >
                        {size.label}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Roles */}
                <div className="bg-white rounded-lg shadow p-6">
                  <div className="flex items-center mb-4">
                    <Briefcase className="text-[#45185a]  mr-2" />
                    <h2 className="text-lg font-medium">Roles / Job Titles</h2>
                  </div>

                  <div className="mb-4">
                    <div className="flex">
                      <input
                        type="text"
                        className="flex-1 p-2 border rounded-l"
                        placeholder="Add custom role or job title"
                        value={newRole}
                        onChange={(e) => setNewRole(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && newRole.trim()) {
                            setSelectedRoles([...selectedRoles, newRole.trim()]);
                            setNewRole('');
                          }
                        }}
                      />
                      <button
                        className="bg-[#45185a] text-white px-4 rounded-r hover:bg-[#5e2c73]"
                        onClick={() => {
                          if (newRole.trim()) {
                            setSelectedRoles([...selectedRoles, newRole.trim()]);
                            setNewRole('');
                          }
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">Press Enter or click Add to add a role</p>
                  </div>

                  <div className="mb-3">
                    <h3 className="text-sm font-medium text-gray-700 mb-2">Common roles (click to add):</h3>
                    <div className="flex flex-wrap gap-2">
                      {roles.map((role) => (
                        <button
                          key={role}
                          //                           className="px-3 py-1.5 rounded-full text-sm font-medium bg-gray-100 text-gray-800 border border-gray-200 hover:bg-gray-200"
                          //                           onClick={() => {
                          //                             if (!selectedRoles.includes(role)) {
                          //                               setSelectedRoles([...selectedRoles, role]);
                          //                             }
                          //                           }}
                          // >
                          className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors 
                            ${selectedRoles.includes(role)
                              ? 'bg-[#cb90fc] text-[#45185a] border border-[#45185a]'
                              : 'bg-gray-100 text-gray-800 border border-gray-200 hover:bg-gray-200'}`}
                          onClick={() => {
                            if (!selectedRoles.includes(role)) {
                              setSelectedRoles([...selectedRoles, role]);
                            }
                          }}
                        >


                          {role}
                        </button>
                      ))}
                    </div>
                  </div>

                  {selectedRoles.length > 0 && (
                    <>
                      <h3 className="text-sm font-medium text-gray-700 mb-2">Selected roles:</h3>
                      <div className="flex flex-wrap gap-2">
                        {selectedRoles.map((role, index) => (
                          <div
                            key={index}
                            className="px-3 py-1.5 rounded-full text-sm font-medium bg-[#cb90fc] text-[#45185a] border border-[#45185a] flex items-center"
                          >
                            {role}
                            <button
                              className="ml-1.5 text-[#45185a]  hover:text-[#5e2c73] font-bold"
                              onClick={() => setSelectedRoles(selectedRoles.filter(r => r !== role))}
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>

                {/* Locations */}
                <div className="bg-white rounded-lg shadow p-6">
                  <div className="flex items-center mb-4">
                    <Globe className="text-[#45185a] mr-2" />
                    <h2 className="text-lg font-medium">Locations</h2>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {locations.map((location) => (
                      <button
                        key={location}
                        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors 
                      ${selectedLocations.includes(location)
                            ? 'bg-[#cb90fc] text-[#45185a] border border-[#45185a]'
                            : 'bg-gray-100 text-gray-800 border border-gray-200 hover:bg-gray-200'}`}
                        onClick={() => handleLocationToggle(location)}
                      >
                        {location}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Custom Filters */}
                {/* <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  <Target className="text-blue-600 mr-2" />
                  <h2 className="text-lg font-medium">Custom Filters</h2>
                </div>
                <button
                  className="text-blue-600 flex items-center text-sm font-medium"
                  onClick={addCustomFilter}
                >
                  <PlusCircle className="w-4 h-4 mr-1" />
                  Add Filter
                </button>
              </div>

              <div className="space-y-3">
                {customFilters.map((filter, index) => (
                  <div key={index} className="flex gap-2">
                    <input
                      type="text"
                      className="flex-1 p-2 border rounded"
                      placeholder="Filter name (e.g., Tech Stack)"
                      value={filter.name}
                      onChange={(e) => updateCustomFilter(index, 'name', e.target.value)}
                    />
                    <input
                      type="text"
                      className="flex-1 p-2 border rounded"
                      placeholder="Value (e.g., Salesforce, HubSpot)"
                      value={filter.value}
                      onChange={(e) => updateCustomFilter(index, 'value', e.target.value)}
                    />
                    <button
                      className="p-2 text-red-600 hover:text-red-800"
                      onClick={() => removeCustomFilter(index)}
                      disabled={customFilters.length === 1 && index === 0}
                    >
                      &times;
                    </button>
                  </div>
                ))}
              </div>
            </div> */}
              </div>

              {/* Right Column - Summary and Actions */}
              <div className="lg:col-span-1">
                <div className="bg-white rounded-lg shadow p-6 sticky top-6">
                  <h2 className="text-lg font-medium mb-4">Your ICP Summary</h2>

                  <div className="space-y-4 mb-6">
                    {selectedIndustries.length > 0 && (
                      <div>
                        <h3 className="text-sm font-medium text-gray-500">Industries</h3>
                        <p className="text-sm">{selectedIndustries.join(', ')}</p>
                      </div>
                    )}

                    {selectedCompanySizes.length > 0 && (
                      <div>
                        <h3 className="text-sm font-medium text-gray-500">Company Sizes</h3>
                        <p className="text-sm">{selectedCompanySizes.map(s => s.label).join(', ')}</p>
                      </div>
                    )}

                    {selectedRoles.length > 0 && (
                      <div>
                        <h3 className="text-sm font-medium text-gray-500">Roles</h3>
                        <p className="text-sm">{selectedRoles.join(', ')}</p>
                      </div>
                    )}

                    {selectedLocations.length > 0 && (
                      <div>
                        <h3 className="text-sm font-medium text-gray-500">Locations</h3>
                        <p className="text-sm">{selectedLocations.join(', ')}</p>
                      </div>
                    )}

                    {/* {customFilters.some(f => f.name && f.value) && (
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">Custom Filters</h3>
                    <ul className="text-sm list-disc pl-4">
                      {customFilters
                        .filter(f => f.name && f.value)
                        .map((filter, index) => (
                          <li key={index}>
                            <span className="font-medium">{filter.name}:</span> {filter.value}
                          </li>
                        ))}
                    </ul>
                  </div>
                )} */}

                    {/* {naturalLanguageDescription && (
                      <div>
                        <h3 className="text-sm font-medium text-gray-500">Natural Language Description</h3>
                        <p className="text-sm text-gray-700">{naturalLanguageDescription}</p>
                      </div>
                    )} */}
                  </div>

                  <div className="space-y-3">
                    <button
                      className="disabled:bg-[#5e2c73b0] w-full py-2 px-4 bg-[#45185a] hover:bg-[#5e2c73] text-white rounded-md flex items-center justify-center transition-colors"
                      onClick={handleGenerateLeads}
                      disabled={!remainingCalls || remainingCalls === 0 || isGenerating}
                    >
                      {isGenerating ? (
                        <>
                          <span className="mr-2">Generating...</span>
                          <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                        </>
                      ) : (
                        <>
                          Generate Leads
                          <ArrowRight className="ml-2 w-4 h-4" />
                        </>
                      )}
                    </button>
                    <span className="flex justify-end text-sm w-full" style={{ marginTop: '0' }}>
                      {remainingCalls === 0
                        ? 'You have reached your daily calls limit.'
                        : `calls remaining: ${remainingCalls} /3 leads lists for today`
                        // : `You have remaining ${remainingCalls} calls out of 3 calls for today.`
                      }
                    </span>
                    {/* <button
                      className="w-full py-2 px-4 border border-[#45185a] text-[#45185a] hover:bg-[#5e2c73] hover:text-white rounded-md flex items-center justify-center transition-colors"
                      onClick={handleSaveProfile}
                    >
                      <Save className="mr-2 w-4 h-4" />
                      Save Profile
                    </button> */}
                  </div>

                  {/* <div className="mt-6 border-t pt-4">
                    <h3 className="text-sm font-medium text-gray-700 mb-2">Saved Profiles</h3>
                    <div className="space-y-2">
                      <button className="w-full text-left p-2 text-sm rounded hover:bg-gray-100 flex justify-between items-center">
                        <span>Enterprise Tech Decision Makers</span>
                        <ChevronRight className="w-4 h-4 text-gray-400" />
                      </button>
                      <button className="w-full text-left p-2 text-sm rounded hover:bg-gray-100 flex justify-between items-center">
                        <span>Healthcare IT Directors</span>
                        <ChevronRight className="w-4 h-4 text-gray-400" />
                      </button>
                      <button className="w-full text-left p-2 text-sm rounded hover:bg-gray-100 flex justify-between items-center">
                        <span>Finance VPs - Growth Stage</span>
                        <ChevronRight className="w-4 h-4 text-gray-400" />
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ICPDefinitionPage;
